import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const notifications = [{
  name: 'Carlos M.',
  country: 'México'
}, {
  name: 'Laura S.',
  country: 'Colombia'
}, {
  name: 'Diego R.',
  country: 'Argentina'
}, {
  name: 'Ana P.',
  country: 'España'
}, {
  name: 'Javier T.',
  country: 'Chile'
}, {
  name: 'Sofía L.',
  country: 'Perú'
}, {
  name: 'Miguel A.',
  country: 'Ecuador'
}, {
  name: 'Valentina C.',
  country: 'Estados Unidos'
}];
export function PurchasePopup() {
  const [currentNotification, setCurrentNotification] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) {
      const nextTimer = setTimeout(() => {
        setCurrentNotification(prev => (prev + 1) % notifications.length);
        setTimeAgo(Math.floor(Math.random() * 10) + 1);
        setIsVisible(true);
      }, Math.random() * 15000 + 10000); // Random delay between 10-25s
      return () => clearTimeout(nextTimer);
    } else {
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 6000); // Show for 6 seconds
      return () => clearTimeout(hideTimer);
    }
  }, [isVisible]);
  if (!isVisible) return null;
  const notification = notifications[currentNotification];
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up-fade max-w-sm w-[calc(100%-2rem)] sm:w-auto" data-id="element-270">
      <div className="bg-[#111] border border-gold/30 rounded-lg shadow-gold p-3 sm:p-4 flex items-start gap-3 relative overflow-hidden" data-id="element-271">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-white" data-id="element-272">
          <X className="w-4 h-4" data-id="element-273" />
        </button>

        <div className="flex-shrink-0 mt-1" data-id="element-274">
          <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-275" />
        </div>

        <div className="flex-1 pr-4" data-id="element-276">
          <p className="text-sm sm:text-base text-white font-medium" data-id="element-277">
            <span className="font-bold text-gold" data-id="element-278">{notification.name}</span> de{' '}
            {notification.country}
          </p>
          <p className="text-xs sm:text-sm text-gray-300 mt-0.5" data-id="element-279">
            Compró La Biblioteca del Éxito™
          </p>
          <p className="text-[10px] sm:text-xs text-gray-500 mt-1" data-id="element-280">
            Hace {timeAgo} minuto{timeAgo !== 1 ? 's' : ''}
          </p>
        </div>
      </div>
    </div>;
}